export const envVars = {
  APP_NAME: 'simulator-mf-dashboard',
  PUBLIC_URL: process.env.PUBLIC_URL || '',
  APP_ENV: process.env.APP_ENV || '',
  API_CUSTOMER_ONBOARDING: process.env.API_CUSTOMER_ONBOARDING || '',
  URL_LEAD_FORM_AUTO: process.env.URL_LEAD_FORM_AUTO || '',
  URL_LEAD_FORM_HOME: process.env.URL_LEAD_FORM_HOME || '',
  URL_LEAD_REVIEW_AUTO: process.env.URL_LEAD_REVIEW_AUTO || '',
  URL_LEAD_REVIEW_HOME: process.env.URL_LEAD_REVIEW_HOME || '',
  URL_LOGIN: process.env.URL_LOGIN || '',
};
